













import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    "date-range-stat": () =>
      import("@/components/app/global/stats/_dateRangeStat.vue")
  }
})
export default class TransactionsTotal extends Vue {
  private get params() {
    return {
      type: "transactions",
      report: `["total"]`,
      date_to: this.$moment().format("YYYY-MM-DD")
    };
  }

  public calcValue({ data, defaultValue }) {
    if (!data) return defaultValue;
    return data;
  }
}
